<div class="container">
  <div class="terceros">
    <p class="arial">¿Se procesa semilla para terceros y/o con fines comerciales?</p>
    <mat-radio-group (change)="onRadioChange($event)" required>
      <mat-radio-button *ngFor="let option of options" [value]="option.value"
        [checked]="option.checked">{{option.label}}</mat-radio-button>
    </mat-radio-group>
  </div>
  <div class="equipamiento">
    <h4 class="secondary-header">Maquinaria</h4>
    <div class="maquinas" *ngFor="let maquina of equipamientos; let i = index">
      <rpe-registro-actividad-maquinarias-moviles-form #registroActividadMaquinariasMovilesForm
        [equipamientosProcesamiento]="maquina.equipamiento"
        (onFormChange)="onEquipamientoProcesamientoChange($event, i)"
        (onFormValid)="onStatusMaquinaChange($event, i)"></rpe-registro-actividad-maquinarias-moviles-form>
      <!-- Se elimino por requerimiento la funcionalidad de agregar mas de un equipamiento a una maquina movil -->
      <!-- <div class="actions">
        <button *ngIf="equipamientos.length > 1" type="button" mat-stroked-button (click)="removeMaquinas(i)"
          color="warn" matTooltip="Eliminar maquina">
          <mat-icon>
            <fa-icon icon="minus"></fa-icon>
          </mat-icon>
          <span>Eliminar máquina</span>
        </button>
      </div> -->
    </div>
    <!-- <div class="actions">
      <button type="button" (click)="addMaquinas()" mat-stroked-button color="primary"
        matTooltip="Agregar nueva maquina">
        <mat-icon>
          <fa-icon icon="plus"></fa-icon>
        </mat-icon>
        <span>Agregar nueva máquina</span>
      </button>
    </div> -->
  </div>
  <div class="contacto">
    <rpe-datos-contacto-form #datosContactoForm (formValueChanges)="onDatoContactoChange($event)"
      [formInput]="datosContacto" (formStatusChanges)="datoContactoStatusChange($event)"></rpe-datos-contacto-form>
  </div>
</div>